module.exports = __webpack_public_path__ + "static/media/xe.847a264a.svg";